import { IntegrationsPageHeader } from './components/IntegrationsPageHeader.main';
import { Integrations } from './Integrations.main';

export { Integrations, IntegrationsPageHeader };
